import Grid from "@mui/material/Grid";
import Slider, { SliderProps } from "@mui/material/Slider";
import { colors } from "../styles";

interface MarkI {
  value: number;
  label?: string;
}

const CustomSlider = (props: SliderProps) => {
  return (
    <>
      <Grid container spacing={2} alignItems="center" marginTop={2}>
        <Grid item padding={0} marginLeft="4px" fontSize={12}>
          <p>
            {props.marks ? (props.marks as Array<MarkI>)[0].label : props.min}
          </p>
        </Grid>
        <Grid container item xs>
          <Slider
            min={props.min || 0}
            max={props.max}
            size="medium"
            getAriaValueText={props.getAriaValueText}
            valueLabelDisplay={props.valueLabelDisplay || "on"}
            valueLabelFormat={props.valueLabelFormat}
            value={props.value}
            onChange={props.onChange}
            sx={{
              color: colors.black,
              height: 8,
              "& .MuiSlider-valueLabel": {
                fontSize: 14,
                top: -6,
                backgroundColor: "unset",
                color: colors.black_800,
                "&:before": {
                  display: "none",
                },
                "& *": {
                  background: "transparent",
                  color: colors.black,
                },
              },
              ...props.sx,
            }}
            disabled={props.disabled}
          />
        </Grid>
        <Grid item fontSize={12}>
          <p>
            {props.marks ? (props.marks as Array<MarkI>)[1].label : props.max}
          </p>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomSlider;
